import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader } from "../../components/ui/card";
import { Progress } from "../../components/ui/progress";
import { cn } from "../../lib/utils";
import { AlertTriangle, CheckCircle } from "lucide-react";
import TokenHistory from "./TokenHistory";

export default function CDDLimit({
  visualUsed = 0,
  visualLimit = 0,
  used = 0,
  limit = 0,
  kybUsed = 0,
  kybLimit = 0,
  userUsed = 0,
  userLimit = 0,
}) {
  const navigate = useNavigate();
  const percent = (used / limit) * 100;
  const kybPercent = (kybUsed / kybLimit) * 100;
  const userPercent = (userUsed / userLimit) * 100;

  // const visualPercent = (visualUsed / visualLimit) * 100;

  const isLimitReached = used >= limit;
  const isLimitKYBReached = kybUsed >= kybLimit;
  const isLimitUserReached = userUsed >= userLimit;
  // const isLimitVisualReached = visualUsed >= visualLimit;

  const message =
    isLimitReached && isLimitKYBReached
      ? "You've hit your limit"
      : "You're within the usage limit";

  return (
    <div className="w-full mx-auto">
      <Card
        className={cn(
          "rounded-2xl shadow-md transition-all duration-300",
          "hover:shadow-xl hover:scale-[1.01]",
          (isLimitReached || isLimitKYBReached || isLimitUserReached) &&
            "border-red-500",
        )}
      >
        <CardHeader>
          <div  className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  isLimitReached || isLimitKYBReached || isLimitUserReached
                    ? "text-red-500"
                    : "text-green-500",
                )}
              >
                {isLimitReached || isLimitKYBReached || isLimitUserReached ? (
                  <AlertTriangle className="w-4 h-4 text-yellow-600" />
                ) : (
                  <CheckCircle className="w-4 h-4 text-green-600" />
                )}
              </span>
              <p className="text-lg font-semibold">{message}</p>
            </div>

            <p className="text-sm text-muted-foreground mt-2">
              {isLimitReached || isLimitKYBReached || isLimitUserReached
                ? "Your current plan has reached its capacity. Upgrade to continue using all features."
                : ""}
            </p>

            <TokenHistory />
          </div>
        </CardHeader>

        <CardContent className="space-y-6">
          {/* Progress */}

          {/* <div>
            <div className="flex justify-between text-sm mb-2">
              <span>Visual</span>
              <span
                className={cn(
                  "font-medium",
                  isLimitVisualReached ? "text-red-500" : "text-green-500",
                )}
              >
                {visualUsed.toLocaleString()} / {visualLimit.toLocaleString()}
              </span>
            </div>

            <Progress
              value={visualPercent}
              className={cn(
                "h-2 transition-all",
                !isLimitVisualReached && "[&>div]:bg-green-500",
                isLimitVisualReached && "[&>div]:bg-red-500",
              )}
            />
          </div> */}

          <div>
            <div className="flex justify-between text-sm mb-2">
              <span>KYC CDDs</span>
              <span
                className={cn(
                  "font-medium",
                  isLimitReached ? "text-red-500" : "text-green-500",
                )}
              >
                {used.toLocaleString()} / {limit.toLocaleString()}
              </span>
            </div>

            <Progress
              value={percent}
              className={cn(
                "h-2 transition-all",
                !isLimitReached && "[&>div]:bg-green-500",
                isLimitReached && "[&>div]:bg-red-500",
              )}
            />
          </div>

          <div>
            <div className="flex justify-between text-sm mb-2">
              <span>KYB CDDs</span>
              <span
                className={cn(
                  "font-medium",
                  isLimitKYBReached ? "text-red-500" : "text-green-500",
                )}
              >
                {kybUsed.toLocaleString()} / {kybLimit.toLocaleString()}
              </span>
            </div>

            <Progress
              value={kybPercent}
              className={cn(
                "h-2 transition-all",
                !isLimitKYBReached && "[&>div]:bg-green-500",
                isLimitKYBReached && "[&>div]:bg-red-500",
              )}
            />
          </div>

          <div>
            <div className="flex justify-between text-sm mb-2">
              <span>Users</span>
              <span
                className={cn(
                  "font-medium",
                  isLimitUserReached ? "text-red-500" : "text-green-500",
                )}
              >
                {userUsed.toLocaleString()} / {userLimit.toLocaleString()}
              </span>
            </div>

            <Progress
              value={userPercent}
              className={cn(
                "h-2 transition-all",
                !isLimitUserReached && "[&>div]:bg-green-500",
                isLimitUserReached && "[&>div]:bg-red-500",
              )}
            />
          </div>

          {/* CTA */}
          <Button
            onClick={() => {
              navigate(`/general-settings?tab=subscription`, {
                state: {
                  planType: "AML/CTF",
                },
              });
            }}
            className="w-full text-base py-5 transition-all hover:scale-[1.02]"
          >
            Add on purchase →
          </Button>

          <p className="text-xs text-center text-muted-foreground">
            Upgrade takes effect immediately
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
